var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('styled-a',{attrs:{"href":_vm.url,"target":"_blank","aria-label":_vm.alt}},[_c('card',[_c('logo',{attrs:{"src":_vm.src,"alt":_vm.alt}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }